module.exports = __webpack_public_path__ + "static/media/plan-wom-gb-libre.501a44b3.svg";